import {Checkbox} from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const CircularCheckBox = ({onClick, checked}: {onClick: (checked: boolean) => void; checked: boolean}) => {
  return (
    <Checkbox
      checked={checked}
      onChange={({target: {checked}}) => {
        onClick(checked);
      }}
      icon={<RadioButtonUncheckedIcon />}
      checkedIcon={<RadioButtonCheckedIcon />}
      size="small"
    />
  );
};

export default CircularCheckBox;
